import React from 'react';
import styled from 'styled-components';

import Section from '../Section';
import Button from '../ui/Button';

const ScheduleDemoSection = () => (
  <StyledSection>
    <Title>Ready to create better shopping experiences?</Title>
    <Description>
      See Commerce7 firsthand by scheduling a demo with our team.
    </Description>
    <Button to="/demo">Schedule a Demo</Button>
  </StyledSection>
);

const StyledSection = styled(Section)`
  background-color: var(--blue-dark);
  text-align: center;
  padding-top: 114px;
  padding-bottom: 120px;
`;

const Title = styled.h2`
  color: var(--white);
  font-size: var(--heading-size-base);
  font-weight: var(--font-weight-bold);
  margin-bottom: 15px;
  line-height: var(--line-height-base);
`;

const Description = styled.p`
  color: var(--white);

  margin: 0 0 30px 0;
  opacity: 65%;
`;

export default ScheduleDemoSection;
